// extracted by mini-css-extract-plugin
export default {"container":"kitStatus_container__uvHoz","wait":"kitStatus_wait__MTT70"};